<script setup lang="ts">
import type { Component } from 'vue'

import { XMarkIcon } from '@heroicons/vue/16/solid'
import { CheckCircleIcon } from '@heroicons/vue/24/solid'

// interface ActionChipDefaultSlotProps {}

// TODO: use emit with optional rendering
interface ActionChipProps {
  label: string
  checkmarkDisabled?: boolean | undefined
  disabled?: boolean | undefined
  icon?: Component | undefined
  image?: string | undefined
  isHighlighted?: boolean | undefined
  onCheckmarkClick?(clickEvent: Event): void
  onIconClick?(clickEvent: Event): void
}

const props = defineProps<ActionChipProps>()

const handleCheckmarkClicked = (event: Event): void => {
  if (!props.checkmarkDisabled) {
    props.onCheckmarkClick?.(event)
  }
}

defineSlots<{
  default?(/*props: ActionChipDefaultSlotProps*/): unknown
}>()
</script>

<!-- this component is an inline html component -->
<template>
  <span
    class="inline-flex items-stretch justify-center rounded-2xl hc:outline hc:outline-1 hc:-outline-offset-1"
    :class="
      props.disabled
        ? 'bg-black-100 hc:outline-black-400'
        : 'bg-lochmara-50 hc:outline-lochmara-600'
    "
  >
    <component
      :is="props.icon"
      v-if="props.icon"
      class="mr-2 aspect-square w-6 min-w-6"
      :image="props.image"
      :name="props.label"
      size="small"
    />
    <span
      class="inline-flex items-center py-0.5 pr-2 text-sm font-normal"
      :class="[
        props.onIconClick ? 'gap-1' : '',
        props.image ? '' : 'pl-2',
        props.disabled ? 'text-black-400' : 'text-lochmara-600',
      ]"
    >
      <span>
        {{ label }}
        <template v-if="isHighlighted"><sup>*</sup></template>
      </span>
      <CheckCircleIcon
        v-if="props.onCheckmarkClick"
        class="size-4 shrink-0"
        :class="[checkmarkDisabled ? 'text-black-400' : 'cursor-pointer text-keppel-600']"
        @click.stop.prevent="handleCheckmarkClicked"
      />
      <XMarkIcon
        v-if="props.onIconClick && !props.disabled"
        class="aspect-square w-4 min-w-4 cursor-pointer"
        @click.stop.prevent="props.onIconClick"
      />
    </span>
  </span>
</template>
